.root {
    padding: var(--mantine-spacing-xs);
    justify-content: flex-end;
    @container (min-width: $mantine-breakpoint-sm) {
        align-self: flex-end;
        padding: var(--mantine-spacing-md);
    }
    &:hover {
        .hidden {
            opacity: 1;
        }
    }
}

.group {
    @container (min-width: $mantine-breakpoint-sm) {
        padding-left: calc(
            var(--mantine-spacing-xl) + var(--mantine-spacing-sm)
        );
    }
}

.centered {
    display: flex;
    justify-content: flex-end;
    width: 48rem;
    margin: 0 auto;
}

.content {
    background: var(--dib-ink);
    color: #fff;
    padding: var(--mantine-spacing-xs) var(--mantine-spacing-xs);
    border: 1px solid transparent;
    border-radius: var(--mantine-radius-md);
    font-size: var(--mantine-font-size-sm);
    white-space: pre-wrap;
    word-break: break-word;
    transition: background 0.3s, border 0.3s, height 0.3s;

    @container (min-width: $mantine-breakpoint-sm) {
        font-size: var(--mantine-font-size-md);
        margin: 0.5rem 0;
        border-radius: var(--mantine-radius-lg);
        padding: var(--mantine-spacing-xs) var(--mantine-spacing-md);
    }
}
.editing {
    background: white;
    color: var(--dib-ink);
    border-color: var(--dib-ink);
}

.edit {
    border: 1px solid var(--mantine-color-gray-3);
    border-radius: var(--mantine-radius-lg);
    flex: 1;
}

.hidden {
    opacity: 0;
    transition: opacity 0.1s;
}

.message {
    align-items: center;
    @container (min-width: $mantine-breakpoint-sm) {
        max-width: var(--mantine-breakpoint-sm);
        flex-wrap: nowrap;
    }
}

.initiateEditGroup {
    position: absolute;
    bottom: -2rem;
    right: 0;

    @container (min-width: $mantine-breakpoint-sm) {
        bottom: 0;
        top: 0;
        left: 0;
        right: auto;
    }
}

.editGroup {
    position: absolute;
    bottom: -2rem;
    right: 0;

    @container (min-width: $mantine-breakpoint-sm) {
        bottom: 0;
        top: 0;
        left: -1rem;
        right: auto;
    }
}
